export const BROADCAST_POLLING_INTERVAL = 60000
export const BROADCAST_CHUNK_SIZE = 100
